import { Toc } from "../Toc";
import { SearchBar } from "../SearchBar";
import { Bookmarks } from "../Bookmarks";
import { Tabs, TabsContent } from "~/components/ui/tabs";
import { FaqSidebarTabs } from "./tabs";

export function FaqSidebar() {

	return (
		<div class="w-[22rem] min-h-[50rem]">
			<Tabs>
				<SearchBar />
				<FaqSidebarTabs />
				<TabsContent value="toc">
					<Toc />
				</TabsContent>
				<TabsContent value="bookmarks">
					<Bookmarks />
				</TabsContent>
			</Tabs>
		</div>
	);
}